module.exports = __webpack_public_path__ + "static/media/6.09af0737.jpg";